module.exports = __webpack_public_path__ + "assets/gui/wavy-error.svg?e81619";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/gui/wavy-error.svg
// module id = 487
// module chunks = 0